import { render, staticRenderFns } from "./post.vue?vue&type=template&id=ea2c4130&scoped=true"
import script from "./post.vue?vue&type=script&lang=js"
export * from "./post.vue?vue&type=script&lang=js"
import style0 from "./post.vue?vue&type=style&index=0&id=ea2c4130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2c4130",
  null
  
)

export default component.exports